import { render, staticRenderFns } from "./NewsPopup.vue?vue&type=template&id=ed086dfa&scoped=true"
import script from "./NewsPopup.vue?vue&type=script&lang=js"
export * from "./NewsPopup.vue?vue&type=script&lang=js"
import style0 from "./NewsPopup.vue?vue&type=style&index=0&id=ed086dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed086dfa",
  null
  
)

export default component.exports